import { render, staticRenderFns } from "./MyOrganisation.vue?vue&type=template&id=1945ecd4&scoped=true"
import script from "./MyOrganisation.vue?vue&type=script&lang=js"
export * from "./MyOrganisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1945ecd4",
  null
  
)

export default component.exports